module.exports = __webpack_public_path__ + "img/tamama.fcf77917.jpg";